module.exports = __webpack_public_path__ + "static/media/Referral_scheme.37d998ce.svg";